import { render, staticRenderFns } from "./FormatItalic.vue?vue&type=template&id=bd33b56e&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatItalic.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/FormatItalic.vue
// module id = 2224
// module chunks = 1